import { NonIndexRouteObject, Outlet } from 'react-router';
import { Suspense } from 'react';

import { DashboardAppsHomeRoute, TowerRoutes } from '../../../../../RouteConstants';
import { HomeLayoutRoutes } from './layouts.home.routes';
import { TabbedLayoutRoutes } from './layouts.tabbed.routes';
import { TowerChildRoutes } from '../../../../TowerLayout/constants/tower.routes';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import { ChunkErrorBoundary, ErrorBoundary, RouteErrorPage } from '@components/ErrorBoundary';

export const ProtectedRoutes: NonIndexRouteObject[] = [
  {
    path: '/',
    hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
    async lazy() {
      const RootLayout = (await import('../../../RootLayout')).default;
      const ProtectedRouteLoader = (await import('../../../utils/protectedRoute.loader')).default;

      return {
        errorElement: <RouteErrorPage />,
        loader: ProtectedRouteLoader,
        element: (
          <ErrorBoundary>
            <ChunkErrorBoundary>
              <Suspense fallback={<LoadingIndicator isLoading />}>
                <RootLayout />
              </Suspense>
            </ChunkErrorBoundary>
          </ErrorBoundary>
        ),
      };
    },
    children: [
      {
        path: `*`,
        hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
        async lazy() {
          const PageNotFoundAuthed = (await import('Modules/PageNotFound/PageNotFoundAuthed'))
            .default;

          return {
            element: <PageNotFoundAuthed />,
            errorElement: <RouteErrorPage />,
          };
        },
      },

      ...HomeLayoutRoutes,
      ...TabbedLayoutRoutes,

      {
        // Tower
        path: `${TowerRoutes.base}`,
        children: [
          {
            path: `*`,
            hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
            async lazy() {
              return {
                errorElement: <RouteErrorPage />,
                element: <Outlet />,
              };
            },

            children: TowerChildRoutes,
          },
        ],
      },

      {
        path: DashboardAppsHomeRoute,
        hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
        async lazy() {
          const DashboardApps = (await import('@Apps/DashboardApps/DashboardApps')).default;

          return {
            errorElement: <RouteErrorPage />,
            element: (
              <ErrorBoundary>
                <DashboardApps />
              </ErrorBoundary>
            ),
          };
        },
      },
    ],
  },
];
